import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=4870c1ae&scoped=true&"
import script from "./Dialog.vue?vue&type=script&lang=ts&"
export * from "./Dialog.vue?vue&type=script&lang=ts&"
import style0 from "./Dialog.vue?vue&type=style&index=0&id=4870c1ae&prod&lang=scss&scoped=true&"
import style1 from "./Dialog.vue?vue&type=style&index=1&id=4870c1ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4870c1ae",
  null
  
)

export default component.exports